<!--
   Created by qing on 2020/9/9
   Des:
-->
<template>

  <van-popup
    v-model="visible"
    :style="{ height: '100%', width: '100%' }"
    get-container="body"
    position="right">
    <div
      :key="canvasBoxKey"
      v-if="!uploadSuc"
      id="canvasBox"
      :class="degree === 0 && orientation === 0 ? 'sign-page': 'rotate-sign-page'"
      :style="getHorizontalStyle">
      <p style="display: flex">
        请在下方区域内横向书写
        <span v-if="hasOtherSign">
          <div class="other-sign-btn" @click="otherSign">
             其他设备签名
          </div>
        </span>
      </p>
      <div
        id="signContainer"
        ref="signContainer"
        class="sign-container">
        <canvas></canvas>
      </div>
      <div
        class="handle-container"
        :style="{paddingRight : hasCancel ? '180px' : '100px'}">
        <van-checkbox
          v-model="saveSign"
          icon-size="16"
          checked-color="#4A66FA"
          shape="square">
          保存签名以备下次调用
        </van-checkbox>
        <span
          class="delete-btn"
          @click="clear">
        <van-icon name="delete"/>
        重写
      </span>
      </div>

      <div class="btn-container">
        <van-button
          v-if="hasCancel"
          class="cancel-btn"
          type="default"
          @click="cancel">
          取消
        </van-button>
        <van-button
          class="save-btn"
          type="primary"
          :style="{width : hasCancel ? '40%' : '90%'}"
          @click="uploadSign">
          确定
        </van-button>
      </div>
      <div
        v-if="this.orientation !== 90"
        class="rotate-btn"
        @click="onClickRotate">
        <i v-if="degree === 0" class="iconfont icon-rotate"></i>
        <i v-else class="iconfont icon-cancel-rotate"></i>
      </div>
    </div>
    <div v-else class="upload-suc-container">
      <van-icon name="checked"/>
      操作成功
    </div>
  </van-popup>
</template>

<script>
  import Draw from './draw';

  export default {
    props: {
      hasCancel: {
        type: Boolean,
        default: true
      },
      hasOtherSign: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible: false,
        saveSignature: 1,
        degree: 90, // 屏幕整体旋转的角度, 可取 -90,90,180等值
        orientation: 0, // 屏幕旋转方向， 90是横屏， 0 是竖屏
        formId: '',
        topic: '',
        fieldId: '',
        subTable: 0,
        rowIdx: 1,
        taskId: '', // 审批意见有此参数
        uploadSuc: false,
        canvasBoxKey: Math.random()
      }
    },
    components: {
      Draw,
    },
    created() {
    },
    mounted() {
      window.addEventListener("orientationchange", () => {

        this.orientation = window.orientation
        this.degree = 0
        const signContainer = this.$refs.signContainer
        const w = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth
        const h = window.innerHeight || d.documentElement.clientHeight || d.body.clientHeight
        if (signContainer) {
          if (window.orientation === 90) {
            signContainer.style.height = `${h}px`
            signContainer.style.width = `${h * 1.765}px`
          } else {
            signContainer.style.width = `${w - 20}px`
            signContainer.style.height = `${(w - 20) / 1.765}px`
          }
        }
        if (this.canvasBox && this.signContainer) {
          this.canvasBox.style.width = `${w}px`
          this.canvasBox.style.height = `${h}px`
          if (document.querySelector('canvas')) {
            this.signContainer.removeChild(document.querySelector('canvas'));
            this.signContainer.appendChild(document.createElement('canvas'));
          }
          setTimeout(() => {
            this.initCanvas();
          }, 200);
        }
      }, false);
    },
    computed: {
      getHorizontalStyle() {
        const d = document;
        const w = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth;
        const h = window.innerHeight || d.documentElement.clientHeight || d.body.clientHeight;
        let length = (h - w) / 2;
        let width = w;
        let height = h;

        switch (this.degree) {
          case -90:
            length = -length;
            break;
          case 90:
            width = h;
            height = w;
            break;
          default:
            length = 0;
        }
        if (this.canvasBox && this.signContainer) {
          this.signContainer.removeChild(document.querySelector('canvas'));
          this.signContainer.appendChild(document.createElement('canvas'));
          setTimeout(() => {
            this.initCanvas();
          }, 200);
        }
        return {
          transform: `rotate(${this.degree}deg) translate(${length}px,${length}px)`,
          width: `${width}px`,
          height: `${height}px`,
          transformOrigin: 'center center',
        };
      },
      saveSign: {
        set(val) {
          this.saveSignature = Number(val)
        },
        get() {
          return Boolean(this.saveSignature)
        }
      }
    },
    methods: {
      open(nodeKey) {
        this.uploadSuc = false
        this.visible = true

        this.$store.dispatch('actionWechatNodeGet', nodeKey)
          .then(res => {
            this.formId = res.formId
            this.topic = res.topic
            this.fieldId = res.fieldId
            this.subTable = res.subTable
            this.rowIdx = res.rowIdx
            this.taskId = res.taskId
          })
          .catch(err => {
            console.error(err)
          })

        this.$nextTick(() => {

          this.canvasBox = document.getElementById('canvasBox')
          this.signContainer = document.getElementById('signContainer')

          const signContainer = this.$refs.signContainer
          const w = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth
          if (signContainer) {
            if (this.degree === 90) {
              signContainer.style.width = `${w * 1.765}px`
              signContainer.style.height = `${w}px`
            } else {
              signContainer.style.width = `${w - 20}px`
              signContainer.style.height = `${(w - 20) / 1.765}px`
            }
          }
          setTimeout(() => {
            this.initCanvas();
          }, 500)
        })
      },
      otherSign() {
        this.visible = false
        this.$emit('otherSign')
      },
      cancel() {
        this.visible = false
        this.$emit('signCancel')
      },
      close() {
        this.visible = false
      },
      onClickRotate() {
        if (this.degree === 0) {
          this.degree = 90
        } else {
          this.degree = 0
        }

        const signContainer = this.$refs.signContainer
        const w = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth
        if (signContainer) {
          if (this.degree === 90) {
            signContainer.style.width = `${w * 1.765}px`
            signContainer.style.height = `${w}px`
          } else {
            signContainer.style.width = `${w - 20}px`
            signContainer.style.height = `${(w - 20) / 1.765}px`
          }
        }
      },
      initCanvas() {
        const canvas = document.querySelector('canvas');
        this.draw = new Draw(canvas, -this.degree);
      },
      clear() {
        this.draw.clear();
      },
      uploadSign() {
        if (!this.draw.isDraw) {
          this.$notify({type: 'warning', message: '请添加签名'});
          return
        }
        const toast = this.$toast.loading({message: '上传中...'})
        this.$store.dispatch('actionSignUpload', {
          formId: this.formId,
          topic: this.topic,
          fieldId: this.fieldId,
          subTable: this.subTable,
          rowIdx: this.rowIdx,
          taskId: this.taskId,
          saveSignature: this.saveSignature,
          signatureInfo: this.draw.getPNGImage()
        }).then(res => {
          this.uploadSuc = true
          this.$emit('signSuccess')
        }).catch(console.error)
          .finally(() => {
            toast.clear()
          })
      },
    },
  }
</script>

<style lang="less">

  .sign-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #ffffff;
    padding: 20px 10px;
    position: relative;

    p {
      font-size: 14px;
      color: #495060;
    }

    .sign-container {
      height: 202px;
      width: 100%;
      margin: 10px 0;
      border: 1px dashed #909399;
      background-color: #fafafa;

      canvas {
        width: 100%;
        height: 100%;
        cursor: crosshair;
      }
    }

    .handle-container {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #495060;
      padding-right: 0 !important;

      .delete-btn {
        display: flex;
        align-items: center;

        .van-icon {
          margin-right: 2px;
          font-size: 16px;
        }
      }
    }
    .other-sign-btn {
      width: 100%;
      text-align: right;
      color: #05A971;
      padding: 0 20px;
      font-size: 13px;
    }

    .btn-container {
      position: fixed;
      bottom: 20px;
      left: 20px;
      right: 20px;
      height: 40px;
      display: flex;
      justify-content: center;

      .cancel-btn {
        border-radius: 30px;
        width: 40%;
        height: 40px;
        margin-right: 20px;
      }

      .save-btn {
        border-radius: 30px;
        width: 40%;
        height: 40px;
      }
    }


    .rotate-btn {
      position: fixed;
      bottom: 100px;
      right: 20px;
      height: 40px;
      width: 40px;
      border-radius: 20px;
      background-color: #4A66FA;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 24px;
        color: #ffffff;
      }
    }
  }

  .rotate-sign-page {
    height: 100%;
    background-color: #ffffff;
    position: relative;

    p {
      font-size: 14px;
      color: #495060;
      position: fixed;
      top: 10px;
      left: 10px;
      z-index: 1;
    }

    .sign-container {
      position: fixed;
      height: 100%;
      bottom: 0;
      top: 0;
      left: 0;

      canvas {
        width: 100%;
        height: 100%;
        cursor: crosshair;
      }
    }

    .other-sign-btn {
      width: 100%;
      text-align: right;
      color: #05A971;
      padding: 0 20px;
      font-size: 13px;
    }
    .handle-container {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #495060;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40px;
      z-index: 1;
      padding: 0 180px 10px 10px;

      .delete-btn {
        display: flex;
        align-items: center;

        .van-icon {
          margin-right: 2px;
          font-size: 16px;
        }
      }
    }

    .btn-container {
      position: fixed;
      bottom: 10px;
      right: 20px;
      height: 30px;
      display: flex;
      justify-content: center;
      z-index: 2;

      .cancel-btn {
        border-radius: 30px;
        width: 70px;
        height: 30px;
        margin-right: 10px;
      }

      .save-btn {
        border-radius: 30px;
        width: 70px !important;
        height: 30px;
      }
    }

    .rotate-btn {
      position: fixed;
      top: 20px;
      right: 40px;
      height: 40px;
      width: 40px;
      border-radius: 20px;
      background-color: #4A66FA;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 24px;
        color: #ffffff;
      }
    }
  }

  .upload-suc-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #05A971;

    .van-icon {
      font-size: 60px;
      margin-bottom: 20px;
      margin-top: 100px;
    }
  }
</style>
